var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('div',{attrs:{"id":"app"}},[_c('BaseSnackbar',{attrs:{"top":"","right":"","data":_vm.snackbar}}),(_vm.isAuthenticated)?_c('TheLayout'):_c('TheSimpleLayout')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }